<template>
  <div class="language-switcher">
    <el-form-item label="Edytowany język">
      <el-radio-group v-model="inputValue" size="medium">
        <el-radio-button
          v-for="language in $store.state.languages"
          :label="language.code"
          :key="language.code"
        >
          <img :src="language.flag" class="flag" /> {{ language.label }}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    inputValue: {
      set(value) {
        this.$store.state.selectedLanguage = value
      },
      get() {
        return this.$store.state.selectedLanguage
      }
    }
  }
}
</script>

<style lang="scss">
.flag {
  height: 12px;
  margin-right: 6px;
  vertical-align: middle;
}
.language-switcher {
  .el-form-item {
    margin: 0 !important;
  }
  .el-form-item__label {
    line-height: 1.4 !important;
    font-weight: 600;
  }
  &--inverse {
    .el-form-item__label {
      color: white;
    }
  }
}
</style>
